import { ChatOverlaySummary, EmoteWallSummary } from 'types/api'

export interface ChatOverlayPreviewConfig {
  textShadow: string
  showTextShadow: boolean
  showBadges: boolean
  showChannelPills: boolean
  usernameFontSize: number
  usernameLineHeight: number
  messageFontSize: number
  messageLineHeight: number
  messageFontWeight: number
  usernameFontWeight: number
  imageScale: number
  messageColor: string
  blockedWords: string[]
  fontFamily: string
  youtubeSourceEnabled: boolean
  youtubeChatChannels: string[]
  twitchChatChannels: string[]
  show7tvEmotes: boolean | null
  showBttvEmotes: boolean | null
  showFfzEmotes: boolean | null
  showYouTubeProfilePictures: boolean | null
}

export interface EmoteWallPreviewConfig {
  style: string
  emoteSize: number
  density: number
  durationSeconds: number
  showTwitchEmotes: boolean
  show7tvEmotes: boolean
  showBttvEmotes: boolean
  showFfzEmotes: boolean
  youtubeChatChannels?: string[]
  source?: 'TWITCH' | 'YOUTUBE'
  blockedWords?: string[]
}

const stringsOf = (raw: unknown): string[] =>
  Array.isArray(raw) ? raw.filter((x): x is string => typeof x === 'string') : []

const nullableBoolean = (raw: unknown): boolean | null =>
  typeof raw === 'boolean' ? raw : null

export const isYouTubeWallConfig = (c: { youtubeChatChannels?: unknown, source?: unknown } | null | undefined): boolean => {
  if (c == null) return false
  if (c.source === 'YOUTUBE') return true
  if (c.source === 'TWITCH') return false
  return stringsOf(c.youtubeChatChannels).length > 0
}

export const chatPreviewConfigFromSummary = (c: ChatOverlaySummary): ChatOverlayPreviewConfig => ({
  textShadow: c.textShadow,
  showTextShadow: c.showTextShadow,
  showBadges: c.showBadges,
  showChannelPills: c.showChannelPills,
  usernameFontSize: c.usernameFontSize,
  usernameLineHeight: c.usernameLineHeight,
  messageFontSize: c.messageFontSize,
  messageLineHeight: c.messageLineHeight,
  messageFontWeight: c.messageFontWeight,
  usernameFontWeight: c.usernameFontWeight,
  imageScale: c.imageScale,
  messageColor: c.messageColor,
  blockedWords: stringsOf(c.blockedWords),
  fontFamily: c.fontFamily,
  youtubeSourceEnabled: c.youtubeSourceEnabled,
  youtubeChatChannels: stringsOf(c.youtubeChatChannels),
  twitchChatChannels: stringsOf(c.twitchChatChannels),
  show7tvEmotes: nullableBoolean(c.show7tvEmotes),
  showBttvEmotes: nullableBoolean(c.showBttvEmotes),
  showFfzEmotes: nullableBoolean(c.showFfzEmotes),
  showYouTubeProfilePictures: nullableBoolean(c.showYouTubeProfilePictures)
})

export const wallPreviewConfigFromSummary = (w: EmoteWallSummary): EmoteWallPreviewConfig => ({
  style: w.style,
  emoteSize: w.emoteSize,
  density: w.density,
  durationSeconds: w.durationSeconds,
  showTwitchEmotes: w.showTwitchEmotes,
  show7tvEmotes: w.show7tvEmotes,
  showBttvEmotes: w.showBttvEmotes,
  showFfzEmotes: w.showFfzEmotes,
  youtubeChatChannels: stringsOf(w.youtubeChatChannels),
  blockedWords: stringsOf(w.blockedWords)
})
